import { CyberSnakesConfig } from './mechanics/cyber-snakes'
import { KenoSnakesConfig } from './mechanics/keno-snakes'
import { LightThreeConfig } from './mechanics/light-three/config'
import { NeonLightsConfig } from './mechanics/neon-lights/config'
import { PlinkoConfig } from './mechanics/plinko/config'
import { RedBallConfig } from './mechanics/red-ball/config'
import { SpaceInvadersConfig } from './mechanics/space-invaders/config'
import { ANIMATION_IDENTIFIERS, DrawAnimationMechanicConfig } from './types'

export const ANIMATION_CONFIG_MAP: Record<ANIMATION_IDENTIFIERS, DrawAnimationMechanicConfig> = {
  [ANIMATION_IDENTIFIERS.DEFAULT]: LightThreeConfig,
  [ANIMATION_IDENTIFIERS.CYBER_SNAKES]: CyberSnakesConfig,
  [ANIMATION_IDENTIFIERS.KENO_SNAKES]: KenoSnakesConfig,
  [ANIMATION_IDENTIFIERS.LIGHT_THREE]: LightThreeConfig,
  [ANIMATION_IDENTIFIERS.NEON_LIGHTS]: NeonLightsConfig,
  [ANIMATION_IDENTIFIERS.PLINKO]: PlinkoConfig,
  [ANIMATION_IDENTIFIERS.RED_BALL]: RedBallConfig,
  [ANIMATION_IDENTIFIERS.SPACE_INVADERS]: SpaceInvadersConfig,
}
